// index.js in React: https://stackoverflow.com/questions/44092341/how-do-index-js-files-work-in-react-component-directories
// This is where the action creators we intend to use externally (i.e. from components) live.
export { fetchScenesIfOK, setCurrentScene } from './scene';
export {
    selectMedia,
    deselectMedia,
    selectAllMedia,
    deselectAllMedia
} from './selectMedia';
export { fetchMediaIfOK, getSearchedMedia } from './fetchMedia';
export {
    fetchSourceMediaFileIfOK,
    clearSourceMediaPreviewValues
} from './fetchSourceMediaFile';
export { deleteSelectedMediaIfOK } from './deleteMedia';
export {
    addMediaIfOK,
    updateAddMediaFormValues,
    clearAddMediaFormValues
} from './addMedia';
export { updateMediaIfOK } from './updateMedia';
export { reprocessSceneIfOK } from './reprocessScene';
export { reprocessSelectedDatasetIfOK } from './reprocessDataset';
export { reprocessSelectedMediaItemIfOK } from './reprocessMediaItem';
export { processCsvIfOK, clearCsvProcessingResults } from './uploadCsv';
export {
    clearBuildBundlesValues,
    updateBuildBundlesValues,
    startBundleBuild
} from './bundles';
export { addSkillDetailsIfOK,
         updateAddSkillDetailsFormValues,
         clearAddSkillDetailsFormValues
} from './addSkillDetails'
export {
    showViewSourceModal, hideViewSourceModal,
    showReprocessingModal, hideReprocessingModal,
    showErrorModal, hideErrorModal,
    showAddSkillDetailsModal, hideAddSkillDetailsModal,
    showAddSceneMediaModal, hideAddSceneMediaModal,
    showDownloadCsvModal, hideDownloadCsvModal,
    showUploadCsvModal, hideUploadCsvModal,
    showCsvResultsModal, hideCsvResultsModal,
    showBuildBundlesModal, hideBuildBundlesModal,
    showCreateActivityModal, hideCreateActivityModal,
    showCreateSkillModal, hideCreateSkillModal,
    showCreateSkillGroupModal, hideCreateSkillGroupModal
} from './modal';
export { startCreateActivityFlow } from './createActivity';
export { setPreviewMediaSource, setMediaRowObject } from './previewMedia';
export {
    receiveAllSkills,
    receiveActivitySkills,
    receiveAllSkillGroups,
    getAllSkills,
    getSkill,
    getActivitySkills
} from './skills';
export { setCurrentPage } from './nav';



// WEBPACK FOOTER //
// ./src/actions/index.js